export const LOCALE_EN_CA = 'en-CA';
